import * as React from 'react';

import { InjectedColorProps } from 'react-color';
import { EditableInput } from 'react-color/lib/components/common';
import styled from 'styled-components';

import { isValidColorHex } from '../../helper';

export interface CustomColorPickerFieldsProps extends InjectedColorProps {
    onChange: (color: any) => void;
}

const StyledCustomColorPickerFields = styled.div`
    width: 80px;
    height: 160px;
    position: relative;
`;

const styles = {
    fieldsWrap: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    input: {
        height: 30,
        width: 65,
        border: '1px solid #f0f0f0',
        paddingLeft: 5,
        marginBottom: '10px',
        boxSizing: 'border-box',
    },
    label: {
        position: 'absolute',
        top: '5px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        height: '18px',
        lineHeight: '22px',
        fontSize: '14px',
    },
} as const;

export const CustomColorPickerFields = React.forwardRef<HTMLDivElement, CustomColorPickerFieldsProps>(
    ({ hex, rgb, onChange, ...props }, ref) => {
        const handleChange = (data: any) => {
            if (data['#']) {
                isValidColorHex(data['#']) &&
                    onChange({
                        hex: data['#'],
                        source: 'hex',
                    });
            } else if (data['R'] || data['G'] || data['B']) {
                onChange({
                    r: data['R'] || rgb?.r,
                    g: data['G'] || rgb?.g,
                    b: data['B'] || rgb?.b,
                    source: 'rgb',
                });
            }
        };

        return (
            <StyledCustomColorPickerFields ref={ref} {...props}>
                <EditableInput
                    style={{ wrap: styles.fieldsWrap, label: styles.label, input: styles.input }}
                    label="R"
                    value={rgb?.r}
                    onChange={handleChange}
                />
                <EditableInput
                    style={{ wrap: styles.fieldsWrap, label: styles.label, input: styles.input }}
                    label="G"
                    value={rgb?.g}
                    onChange={handleChange}
                />
                <EditableInput
                    style={{ wrap: styles.fieldsWrap, label: styles.label, input: styles.input }}
                    label="B"
                    value={rgb?.b}
                    onChange={handleChange}
                />
                <EditableInput
                    style={{ wrap: styles.fieldsWrap, label: styles.label, input: styles.input }}
                    label="#"
                    value={hex?.replace('#', '')}
                    onChange={handleChange}
                />
            </StyledCustomColorPickerFields>
        );
    },
);

CustomColorPickerFields.displayName = 'CustomColorPickerFields';
